export enum Right {
    SSO = 1,
    IMLK_MANEGER = 2,
    IMLK_VIEWER = 3,
    WORKFLOW_MANEGER = 4,
    WORKFLOW_VIEWER = 5,
    DEWAN_MANEGER = 6,
    DEWAN_VIEWER = 7
}